import {Badge, view} from '@sail/ui';
import {FormattedMessage, defineMessages} from 'react-intl';
import {VerificationIssueTime} from './MerchantVerificationAffectingPayouts';

const messages = defineMessages({
  payoutStatusTitle: {
    id: 'mse_inline_data.merchant_verification_affecting_payouts.payout_status_title',
    description:
      'Title next to the payout status type label when a verification issue is present.',
    defaultMessage: 'Payout Status',
  },
  payoutsPausedSubtitle: {
    id: 'mse_inline_data.merchant_verification_affecting_payouts.payouts_paused_subtitle',
    description:
      'Subtitle text when payouts are paused due to a verification issue',
    defaultMessage: 'Payouts paused',
  },
  payoutsPotentialIssueSubtitle: {
    id: 'mse_inline_data.merchant_verification_affecting_payouts.payouts_potential_issue_subtitle',
    description:
      'Subtitle text when payouts are potentially paused soon due to a verification issue',
    defaultMessage: 'Potential issue',
  },
  payoutsPausedInstructions: {
    id: 'mse_inline_data.merchant_verification_affecting_payouts.payouts_paused_now_instructions',
    description:
      'Message when payouts are currently paused due to a verification issue.',
    defaultMessage:
      'There is an issue relating to the verification of your account which is currently affecting payouts.',
  },
  payoutsPausedSoonInstructions: {
    id: 'mse_inline_data.merchant_verification_affecting_payouts.payouts_paused_soon_instructions',
    description:
      'Message when payouts may be paused soon due to a verification issue.',
    defaultMessage:
      'An issue relating to the verification of your account may affect future payouts.',
  },
});

export const VerificationIssueSection = ({
  verificationIssueTime,
}: {
  verificationIssueTime?: VerificationIssueTime;
}) => {
  return (
    <view.div css={{stack: 'y', gap: 'medium'}}>
      <view.div css={{stack: 'y', gap: 'xsmall'}}>
        <view.div
          data-testid="payout-status-title"
          css={{font: 'label.medium.emphasized'}}
        >
          <FormattedMessage {...messages.payoutStatusTitle} />
        </view.div>
        <view.div data-testid="payout-status-label">
          {verificationIssueTime === 'blocked_now' ? (
            <Badge type="negative">
              <FormattedMessage {...messages.payoutsPausedSubtitle} />
            </Badge>
          ) : (
            <Badge type="warning">
              <FormattedMessage {...messages.payoutsPotentialIssueSubtitle} />
            </Badge>
          )}
        </view.div>
      </view.div>
      <view.div css={{font: 'label.medium'}}>
        {verificationIssueTime === 'blocked_now' ? (
          <FormattedMessage {...messages.payoutsPausedInstructions} />
        ) : (
          <FormattedMessage {...messages.payoutsPausedSoonInstructions} />
        )}
      </view.div>
    </view.div>
  );
};
